import React, { useCallback, useState } from 'react';
import { Card } from 'react-bootstrap';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { ExternalReferralSearch } from '../../components/ExternalReferral/ExternalReferralSearch';

export const ExternalReferralsView: React.FC = () => {
  const spd = useSpdCore();
  const [refresh, setRefresh] = useState<boolean>(false);

  const onRefresh = () => {
    setRefresh(prev => !prev);
  };

  const getData = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
    ) =>
      spd.externalReferrals.getByUserCompanyByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        onRefresh,
      ),
    [spd.externalReferrals],
  );

  return (
    <Card>
      <Card.Title className="p-3">
        Lista utworzonych skierowań zewnętrznych
      </Card.Title>
      <ExternalReferralSearch
        getData={getData}
        getCount={spd.externalReferrals.getByUserCompanyCount}
        initialOrderColumn="exams.registrationDate"
        initialOrderDirection="DESC"
        onlyExternalRegistration={true}
        refresh={refresh}
      />
    </Card>
  );
};
